import storage from "./storage"

const log = {
	loginBlockNotificationKey: "login_block_notification",
	scheduleLoginBlockNotification() {
		storage.set(this.loginBlockNotificationKey, true)
	},
	wasPreviouslyLoginBlockNotified() {
		const loginBlockNotification = storage.get(this.loginBlockNotificationKey)

		if (loginBlockNotification === false) {
			return true
		}

		return false
	},
	disableLoginBlockNotification() {
		storage.set(this.loginBlockNotificationKey, false)
	}
}

export default log
